<template>
  <div class="m-3">
    <h6>{{ month | monthOfYear }}</h6>
    <div class="meter-calendar">
      <div
        v-for="day in calendarItems"
        :key="day.day"
        :data-date="day.date"
        :class="{
          pointer: select && day.variant !== 'secondary',
          'meter-calendar__day--active': day.isSelected,
        }"
        class="meter-calendar__day"
        @click="selectedDate = day"
      >
        <div
          class="status-indicator"
          :class="`status-indicator--${day.variant}`"
        ></div>
        <div>{{ day.day }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'CardHalfHourlyCalendar',

	props: {
		value: {},
		month: {
			type: String,
			default: moment()
				.startOf('month')
				.format(),
		},
		select: { type: Boolean },

		AdvancesUntil: { type: String, required: false, default: '' },
	},

	computed: {
		selectedDate: {
			get() {
				return this.value;
			},
			set(day) {
				if (this.select && day.variant !== 'secondary') {
					this.$emit('input', day.date);
				}
			},
		},

		calendarItems() {
			let items = [];

			for (let day = 1; day <= this.daysInMonth; day++) {
				let date = moment(this.month).date(day);
				items.push({
					date: date.format('YYYY-MM-DD'),
					day,
					isSelected: this.select && moment(date).isSame(this.value, 'day'),
					variant: this.getColourVariant(date),
				});
			}

			return items;
		},

		daysInMonth() {
			// Returns the number of days in the month
			return moment(this.month)
				.endOf('month')
				.date();
		},

		advances() {
			return this.$store.state.meters.advances || [];
		},
	},

	methods: {
		getColourVariant(date) {
			const ragRanges = this.$store.state.meters.advanceRAGRanges;

			if (ragRanges && ragRanges.length > 0) {
				const matchingRange = ragRanges.find((range) => {
					return moment(date).isBetween(
						range.FromDate,
						range.ToDate,
						'day',
						'[]'
					);
				});

				if (matchingRange) {
					switch (matchingRange.Colour) {
						case 'Green':
							return 'success';
						case 'Amber':
							return 'warning';
						case 'Red':
							return 'danger';
						default:
							return 'secondary'; // Fallback for unknown colors
					}
				}
			}
			return 'secondary'; // Default if no RAG range matches or RAG data is not available
		},
	},

	filters: {
		monthOfYear(date) {
			return moment(date).format('MMMM YYYY');
		},
	},
};
</script>
					this.advances &&
					this.advances.some((advance) =>
						moment(date).isSame(
							advance.AdvanceDate || advance.Date || advance,
							'day'
						)
					)
				);
			}
			// If in a gap, use the original partial logic
			return (
				(moment(date).isSame(gap.FromDate, 'days') && gap.FromPeriod > 1) ||
				(moment(date).isSame(gap.ToDate, 'days') && gap.ToPeriod < 48)
			);
		},
	},

	filters: {
		monthOfYear(date) {
			return moment(date).format('MMMM YYYY');
		},
	},
};
</script>
